import angular, { ILogService, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import {
  ICVHistoricoBusqueda,
  IModelCurriculum,
  IPeticionCoincidencias,
  ISeleccionPeticionCoincidencias,
} from 'src/model/candidato-api'
import { BaseFeaturesComponent } from '../_base/base-features.component'
import { chunk } from 'lodash'

class PanelCoincidenciasHistoricComponentCtrl extends BaseFeaturesComponent {
  filtroHist = {
    value: null as string | null,
    nregs: 20,
    npage: 0,
    lote: 10,
    lotePend: 10,
    noBuscarPend: false,
  }

  loteActual = ''
  lotePendActual = ''

  listado = {
    valido: false,
    list: [] as ICVHistoricoBusqueda[],
  }

  panelcv = {
    $visible: false,
    cv: null as ICVHistoricoBusqueda,
  }
  datosTipos: TiposDocEstadosStore

  constructor(
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos,
    appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }

  $onInit(): void {
    this.$log.info('[PanelCoincidenciasHistoricComponentCtrl] onInit')
  }

  buscarRelacionadosCv() {
    this._callBackCoincidenciasCv(this.filtroHist.value) //
      .then((listadoRes) => {
        // this.listado.list = listadoRes.cvList
        this.listado.valido = true
      })
  }

  async buscarRelacionadosLotes() {
    // obtener todos los registros de curriculums
    const cvs = await this.AccesoDatos.GestionCurr_CLIENT.regsCV({
      num: this.filtroHist.nregs || 10,
      pag: this.filtroHist.npage || 0,
    })

    if (this.filtroHist.lote > 0) {
      this.buscarRelacionadosPorLote(cvs.content, this.filtroHist.lote, 'loteActual')
    }
  }

  async buscarRelacionadosPendLotes() {
    // obtener todos los registros de curriculums
    const cvs_content = await this.AccesoDatos.HistoricCurr_CLIENT.regsCVPendientesHist()

    if (!this.filtroHist.noBuscarPend) {
      this.buscarRelacionadosPorLote(cvs_content, this.filtroHist.lotePend, 'lotePendActual')
    }
  }

  async buscarRelacionadosPorLote(list: IModelCurriculum[], lote: number, propLog: 'loteActual' | 'lotePendActual') {
    // generar de 10 en 10 y procesarlos secuencialmente
    const chunks = chunk(list, lote || 10)
    const nlotes = chunks.length - 1
    for (let $idx = 0; $idx < chunks.length; $idx++) {
      this[propLog] = ` *** ${$idx} / ${nlotes} *** `
      const chunk = chunks[$idx]
      const rel = await this.buscarRelacionados(
        'CVS',
        chunk.map((c) => c.idcv) // los ids
      )
      console.log('----> rel ', $idx)
    }

    this.$timeout(() => {
      this[propLog] = ' *** finalizado ***'
    }, 500)

    this.$timeout(() => {
      this[propLog] = ''
    }, 2500)
  }

  async buscarRelacionados(seleccion: ISeleccionPeticionCoincidencias, idcvs?: number[]) {
    var _f: IPeticionCoincidencias = {
      idsCv: [],
      limit: 1000,
      seleccion,
    }

    if (seleccion === 'CVS') {
      _f.idsCv = idcvs ? idcvs : this.filtroHist.value ? [Number(this.filtroHist.value)] : []
    }

    if (seleccion === 'TODOS' || seleccion === 'PENDIENTES') {
      if (!confirm('Esto son demasiados!!!!  ¿seguir?')) {
        return
      }
    }

    const listadoRes = await this._callBackCoincidenciasSeleccion(_f) //

    // this.listado.list = listadoRes.cvList
    this.listado.valido = true

    return listadoRes
  }

  private _callBackCoincidenciasCv(idcv: string) {
    return this.AccesoDatos.HistoricCurr_CLIENT.buscarHistoricosRelacionados(Number(idcv))
  }

  private _callBackCoincidenciasSeleccion(pet: IPeticionCoincidencias) {
    return this.AccesoDatos.HistoricCurr_CLIENT.buscarCoincidenciasHistorico(pet)
  }

  accesscvhist(idx: number) {
    this.$log.debug('access', this.listado.list[idx])
    this.panelcv.cv = this.listado.list[idx]
    this.panelcv.$visible = true
  }
}

angular.module('candidato').component('panelCoincidenciasHistoric', {
  bindings: {},
  controller: PanelCoincidenciasHistoricComponentCtrl,
  // templateUrl: "panel-busqueda-historic.component.html",
  template: require('./panel-coincidencias-historic.component.html'),
})
